// Perfiles metrológicos de Analítica.
// Convención única: error = indicación del instrumento - valor certificado.

const SQRT3 = Math.sqrt(3);

export const ANALYTICAL_TEMPLATES = [
  {
    code: 'ANALYTICAL-PH:ph_meter:v1', revision: '1', profileKey: 'ph_meter', subfamily: 'ph',
    profileLabel: 'pHmetro', title: 'Calibración de pHmetros', objectFallback: 'pHmetro', unit: 'pH',
    pointCount: 3, repeatCount: 3, functionKeys: ['ph_buffer_reference'], defaultSetpoints: [4, 7, 10.02],
    method: 'Por comparación directa con materiales de referencia certificados de pH a temperatura controlada.',
    procedure: 'P-DT-PT-21-00 (Calibración de pHmetros)',
  },
  {
    code: 'ANALYTICAL-CONDUCTIVITY:conductivity_meter:v1', revision: '1', profileKey: 'conductivity_meter', subfamily: 'conductivity',
    profileLabel: 'Conductivímetro', title: 'Calibración de conductivímetros', objectFallback: 'Conductivímetro', unit: 'µS/cm',
    pointCount: 2, repeatCount: 2, readingLabels: ['Verificación inicial', 'Calibración / ajuste'],
    functionKeys: ['conductivity_reference'], defaultSetpoints: [1414, 12910],
    method: 'Por comparación directa con soluciones de conductividad certificadas a 25 °C.',
    procedure: 'P-DT-PT-27-00 (Calibración de conductivímetros)',
  },
  {
    code: 'ANALYTICAL-TURBIDITY:turbidimeter:v1', revision: '1', profileKey: 'turbidimeter', subfamily: 'turbidity',
    profileLabel: 'Turbidímetro', title: 'Calibración de turbidímetros', objectFallback: 'Turbidímetro', unit: 'NTU',
    pointCount: 4, repeatCount: 2, readingLabels: ['Verificación inicial', 'Calibración / ajuste'],
    functionKeys: ['turbidity_reference'], defaultSetpoints: [10.2, 20.5, 103, 814.3],
    method: 'Por comparación directa con materiales de referencia StablCal/Formazina certificados por lote.',
    procedure: 'P-DT-PT-27-00 (Calibración de turbidímetros)',
  },
  {
    code: 'ANALYTICAL-DO:oximeter:v1', revision: '1', profileKey: 'oximeter', subfamily: 'dissolved_oxygen',
    profileLabel: 'Oxímetro', title: 'Calibración de medidores de oxígeno disuelto', objectFallback: 'Oxímetro', unit: '% sat',
    pointCount: 2, repeatCount: 2, functionKeys: ['dissolved_oxygen_reference'], defaultSetpoints: [0, 100],
    method: 'Ajuste y verificación en cero de oxígeno y aire saturado, con compensación barométrica y térmica.',
    procedure: 'Metodología especificada por el fabricante del instrumento.',
  },
  {
    code: 'ANALYTICAL-BRIX:refractometer:v1', revision: '1', profileKey: 'refractometer', subfamily: 'refractometry',
    profileLabel: 'Refractómetro', title: 'Calibración de refractómetros', objectFallback: 'Refractómetro', unit: '%Brix',
    pointCount: 6, repeatCount: 1, functionKeys: ['brix_reference'], defaultSetpoints: [0, 10, 30, 50, 80, 100],
    method: 'Por comparación con soluciones acuosas de sacarosa de fracción másica conocida y temperatura controlada.',
    procedure: 'Procedimiento interno de calibración de refractómetros.',
  },
  {
    code: 'ANALYTICAL-ALCOHOL:alcohol_meter:v1', revision: '1', profileKey: 'alcohol_meter', subfamily: 'alcohol',
    profileLabel: 'Alcoholímetro', title: 'Calibración de alcoholímetros', objectFallback: 'Alcoholímetro', unit: 'mg/L',
    pointCount: 3, repeatCount: 1, functionKeys: ['alcohol_reference'], defaultSetpoints: [0.1, 0.5, 0.7],
    method: 'Por contrastación con soluciones hidroalcohólicas de concentración certificada.',
    procedure: 'Procedimiento interno de calibración de alcoholímetros.',
  },
  {
    code: 'ANALYTICAL-DENSITY:density_meter:v1', revision: '1', profileKey: 'density_meter', subfamily: 'density',
    profileLabel: 'Densímetro', title: 'Calibración de densímetros', objectFallback: 'Densímetro', unit: 'g/cm³',
    pointCount: 3, repeatCount: 1, functionKeys: ['density_reference'], defaultSetpoints: [1.025, 1.055, 1.09],
    method: 'Por comparación con muestras de densidad certificada a temperatura controlada.',
    procedure: 'Procedimiento interno de calibración de densímetros.',
  },
  {
    code: 'ANALYTICAL-BAUME:must_meter:v1', revision: '1', profileKey: 'must_meter', subfamily: 'density',
    profileLabel: 'Mostímetro Baumé', title: 'Calibración de mostímetros Baumé', objectFallback: 'Mostímetro', unit: '°Bé',
    pointCount: 3, repeatCount: 1, functionKeys: ['baume_reference'], defaultSetpoints: [3.54, 7.54, 11.97],
    method: 'Por comparación con soluciones de densidad certificada y conversión documentada a grados Baumé.',
    procedure: 'Procedimiento interno de calibración de mostímetros.',
  },
  {
    code: 'ANALYTICAL-VOLUME:volumetric:v1', revision: '1', profileKey: 'volumetric', subfamily: 'volumetric',
    profileLabel: 'Bureta / probeta / micropipeta', title: 'Calibración gravimétrica de material volumétrico', objectFallback: 'Material volumétrico', unit: 'µL',
    pointCount: 3, repeatCount: 5, functionKeys: ['volumetric_gravimetric_reference'], defaultSetpoints: [1000, 2500, 5000],
    method: 'Determinación gravimétrica del volumen dispensado con agua y balanza de referencia.',
    procedure: 'Procedimiento interno de calibración de material volumétrico.',
  },
];

const ENVIRONMENT_READINGS = [
  { key: 'start', label: 'Inicio', temp_c: null, pressure_hpa: null, humidity_rh: null },
  { key: 'middle', label: 'Mitad', temp_c: null, pressure_hpa: null, humidity_rh: null },
  { key: 'end', label: 'Fin', temp_c: null, pressure_hpa: null, humidity_rh: null },
];

export const DEFAULT_ANALYTICAL_FAMILY_DATA = {
  profile_key: 'ph_meter', profile_label: 'pHmetro', method: '', procedure: '',
  tolerance_mode: 'absolute', decision_rule: 'simple', standard_configuration: { references: [] },
  standard_budget: {
    drift: 0, repeatability_limit: 0, temperature_influence: 0, preparation: 0,
    homogeneity: 0, stability: 0, handling: 0, other: 0,
  },
  environment_readings: ENVIRONMENT_READINGS,
  test_configuration: {
    solution_temperature_c: null, stabilization_seconds: null, adjustment_performed: false,
    electrode_condition: '', probe_id: '', temperature_compensation: 'Automática', cell_constant: '',
    sample_homogenized: false, vial_clean: false, bubble_free: false,
    membrane_condition: '', barometric_compensation: false,
    prism_clean: false, atc_enabled: false, sample_identification: '',
    water_temperature_c: null, balance_reference: '', density_formula: '',
  },
};

export function resolveAnalyticalTemplate(templateCode) {
  return ANALYTICAL_TEMPLATES.find((item) => item.code === templateCode) || ANALYTICAL_TEMPLATES[0];
}

export function defaultAnalyticalFamilyData(templateCode) {
  const template = resolveAnalyticalTemplate(templateCode);
  return {
    ...DEFAULT_ANALYTICAL_FAMILY_DATA,
    profile_key: template.profileKey,
    profile_label: template.profileLabel,
    method: template.method,
    procedure: template.procedure,
    standard_budget: { ...DEFAULT_ANALYTICAL_FAMILY_DATA.standard_budget },
    standard_configuration: { references: [] },
    environment_readings: ENVIRONMENT_READINGS.map((item) => ({ ...item })),
    test_configuration: { ...DEFAULT_ANALYTICAL_FAMILY_DATA.test_configuration },
  };
}

export function mergeAnalyticalFamilyData(value = {}, templateCode = null) {
  const input = value && typeof value === 'object' ? value : {};
  const inferredCode = templateCode || input.template_code || ANALYTICAL_TEMPLATES.find((item) => item.profileKey === input.profile_key)?.code;
  const defaults = defaultAnalyticalFamilyData(inferredCode);
  const readings = Array.isArray(input.environment_readings) ? input.environment_readings : [];
  const references = Array.isArray(input?.standard_configuration?.references) ? input.standard_configuration.references : [];
  return {
    ...defaults, ...input,
    standard_budget: { ...defaults.standard_budget, ...(input.standard_budget || {}) },
    test_configuration: { ...defaults.test_configuration, ...(input.test_configuration || {}) },
    standard_configuration: { ...(input.standard_configuration || {}), references },
    environment_readings: defaults.environment_readings.map((fallback, index) => ({
      ...fallback, ...(readings[index] || readings.find((item) => item?.key === fallback.key) || {}),
    })),
  };
}

export function buildAnalyticalBlocks(templateCode) {
  const template = resolveAnalyticalTemplate(templateCode);
  return [{
    block_key: template.subfamily, display_name: template.profileLabel, unit: `[${template.unit}]`,
    applicable: true, point_count: template.pointCount, sort_order: 1, mode: 'comparison',
  }];
}

export function analyticalReadingPairs(templateCode) {
  const template = resolveAnalyticalTemplate(templateCode);
  return Array.from({ length: template.repeatCount }, (_, index) => ({
    key: `reading_${index + 1}`, direction: 'NA', seriesNo: index + 1,
    label: template.readingLabels?.[index] || (template.repeatCount === 1 ? 'Comparación' : `Lectura ${index + 1}`),
    patternField: `reading_${index + 1}_pattern`, instrumentField: `reading_${index + 1}_instrument`,
  }));
}

export function finiteOrNull(value) {
  if (value === '' || value === null || value === undefined) return null;
  const number = Number(value);
  return Number.isFinite(number) ? number : null;
}

function normalizedUnit(value) {
  return String(value || '').trim().toLowerCase().replace(/μ/g, 'µ').replace(/º/g, '°').replace(/\s+/g, '');
}

export function analyticalToCanonical(value, unit, templateCode) {
  const numeric = finiteOrNull(value);
  if (numeric === null) return null;
  const template = resolveAnalyticalTemplate(templateCode);
  const source = normalizedUnit(unit || template.unit);
  if (template.profileKey === 'ph_meter') {
    if (['ph', 'uph', 'unidadph', 'unidadesph', 'phunit', 'phunits'].includes(source)) return numeric;
  } else if (template.profileKey === 'conductivity_meter') {
    if (['µs/cm', 'us/cm', 'µscm', 'uscm'].includes(source)) return numeric;
    if (['ms/cm', 'mscm'].includes(source)) return numeric * 1000;
    if (['s/cm', 'scm'].includes(source)) return numeric * 1e6;
  } else if (template.profileKey === 'turbidimeter') {
    if (['ntu', 'fnu'].includes(source)) return numeric;
  } else if (template.profileKey === 'oximeter') {
    if (['%sat', '%saturacion', '%saturación', '%'].includes(source)) return numeric;
  } else if (template.profileKey === 'refractometer') {
    if (['%brix', 'brix', '°brix'].includes(source)) return numeric;
  } else if (template.profileKey === 'alcohol_meter') {
    if (['mg/l', 'mgl'].includes(source)) return numeric;
    if (['g/l', 'gl'].includes(source)) return numeric * 1000;
  } else if (template.profileKey === 'density_meter') {
    if (['g/cm3', 'g/cm³', 'gcm3'].includes(source)) return numeric;
    if (['kg/m3', 'kg/m³', 'kgm3'].includes(source)) return numeric / 1000;
  } else if (template.profileKey === 'must_meter') {
    if (['°bé', 'bé', 'be', 'baume', 'baumé'].includes(source)) return numeric;
  } else if (template.profileKey === 'volumetric') {
    if (['µl', 'ul'].includes(source)) return numeric;
    if (['ml'].includes(source)) return numeric * 1000;
    if (['l'].includes(source)) return numeric * 1e6;
  }
  throw new Error(`La unidad ${unit || '(sin unidad)'} no es compatible con ${template.profileLabel}.`);
}

export function suggestAnalyticalSetpoints(rangeMin, rangeMax, templateCode) {
  const template = resolveAnalyticalTemplate(templateCode);
  const min = finiteOrNull(rangeMin);
  const max = finiteOrNull(rangeMax);
  const filtered = template.defaultSetpoints.filter((value) => (min === null || value >= min) && (max === null || value <= max));
  return filtered.length ? filtered : [...template.defaultSetpoints];
}

function mean(values = []) {
  const finite = values.map(finiteOrNull).filter((value) => value !== null);
  return finite.length ? finite.reduce((sum, value) => sum + value, 0) / finite.length : null;
}

function sampleStandardDeviation(values = []) {
  const finite = values.map(finiteOrNull).filter((value) => value !== null);
  if (finite.length < 2) return 0;
  const average = mean(finite);
  return Math.sqrt(finite.reduce((sum, value) => sum + ((value - average) ** 2), 0) / (finite.length - 1));
}

function rss(values = []) {
  return Math.sqrt(values.reduce((sum, value) => sum + ((finiteOrNull(value) ?? 0) ** 2), 0));
}

function evaluateSnapshot(value, snapshot = {}) {
  const raw = finiteOrNull(value);
  if (raw === null) return { valid: false, reason: 'Lectura patrón vacía.' };
  const capability = snapshot.capability || {};
  const rangeMin = finiteOrNull(capability.range_min);
  const rangeMax = finiteOrNull(capability.range_max);
  if (rangeMin !== null && raw < rangeMin) return { valid: false, reason: 'El valor está por debajo del alcance del material de referencia.' };
  if (rangeMax !== null && raw > rangeMax) return { valid: false, reason: 'El valor supera el alcance del material de referencia.' };
  const results = Array.isArray(snapshot.results) ? snapshot.results : [];
  const tolerance = Math.max(Math.abs(finiteOrNull(capability.resolution) || 0) / 2, Math.abs(raw) * 1e-8, 1e-9);
  const exact = results.find((item) => {
    const axis = finiteOrNull(item.reference_value) ?? finiteOrNull(item.indicated_value);
    return axis !== null && Math.abs(axis - raw) <= tolerance;
  });
  if (!exact) return { valid: false, reason: 'El valor no coincide con un punto certificado de los materiales fijados.' };
  const referenceValue = finiteOrNull(exact.reference_value) ?? raw;
  const correction = finiteOrNull(exact.correction) ?? (referenceValue - (finiteOrNull(exact.indicated_value) ?? raw));
  const expanded = finiteOrNull(exact.uncertainty_expanded) ?? finiteOrNull(capability?.metadata?.certified_uncertainty);
  const k = finiteOrNull(exact.coverage_factor) || finiteOrNull(snapshot?.certificate?.coverage_factor) || 2;
  if (expanded === null || k <= 0) return { valid: false, reason: 'El punto certificado no tiene incertidumbre utilizable.' };
  return {
    valid: true, corrected_value: referenceValue, correction, standard_uncertainty: Math.abs(expanded) / k,
    uncertainty_expanded: Math.abs(expanded), coverage_factor: k,
  };
}

export function evaluateAnalyticalReference(value, session = {}) {
  const data = mergeAnalyticalFamilyData(session.family_data, session.template_code);
  const references = data.standard_configuration?.references || [];
  if (!references.length) return { valid: false, reason: 'No hay materiales de referencia fijados en la sesión.' };
  const attempts = references.map((snapshot) => evaluateSnapshot(value, snapshot));
  return attempts.find((attempt) => attempt.valid) || {
    valid: false,
    reason: attempts.map((attempt) => attempt.reason).filter(Boolean)[0] || 'Los materiales fijados no cubren este valor.',
  };
}

export function computeAnalyticalPointMetrics(row = {}, session = {}) {
  const expectedPairs = analyticalReadingPairs(session.template_code).map((pair) => ({
    ...pair, pattern: finiteOrNull(row[pair.patternField]), instrument: finiteOrNull(row[pair.instrumentField]),
  }));
  const hasInstrumentReading = expectedPairs.some((pair) => pair.instrument !== null);
  if (!hasInstrumentReading) return null;
  const incompletePair = expectedPairs.find((pair) => pair.pattern === null || pair.instrument === null);
  if (incompletePair) {
    return { traceability_issue: `El punto tiene lecturas incompletas. Completá las ${expectedPairs.length} comparación(es) requeridas.` };
  }
  const pairs = expectedPairs;
  const evaluations = pairs.map((pair) => evaluateAnalyticalReference(pair.pattern, session));
  const invalid = evaluations.find((item) => !item.valid);
  if (invalid) return { traceability_issue: invalid.reason };
  const corrected = evaluations.map((item) => item.corrected_value);
  const indications = pairs.map((item) => item.instrument);
  const patternMean = mean(corrected);
  const rangeMin = finiteOrNull(session.instrument_range_min);
  const rangeMax = finiteOrNull(session.instrument_range_max);
  if (rangeMin !== null && patternMean < rangeMin) return { traceability_issue: 'El punto certificado está por debajo del alcance declarado del instrumento.' };
  if (rangeMax !== null && patternMean > rangeMax) return { traceability_issue: 'El punto certificado supera el alcance declarado del instrumento.' };
  const instrumentMean = mean(indications);
  const errorAbs = instrumentMean - patternMean;
  const errorPct = patternMean === 0 ? null : errorAbs / patternMean * 100;
  const repeatability = sampleStandardDeviation(indications);
  const referenceRepeatability = sampleStandardDeviation(corrected);
  const count = Math.max(1, indications.length);
  const data = mergeAnalyticalFamilyData(session.family_data, session.template_code);
  const budget = data.standard_budget || {};
  const uStandard = Math.max(...evaluations.map((item) => item.standard_uncertainty), 0);
  const uResolution = Math.abs(finiteOrNull(session.instrument_resolution) || 0) / Math.sqrt(12);
  const uRepeatability = rss([
    repeatability / Math.sqrt(count), referenceRepeatability / Math.sqrt(count),
    Math.abs(finiteOrNull(budget.repeatability_limit) || 0) / SQRT3,
  ]);
  const uDrift = Math.abs(finiteOrNull(budget.drift) || 0) / SQRT3;
  const uTemp = Math.abs(finiteOrNull(budget.temperature_influence) || 0) / SQRT3;
  const uOther = rss([
    Math.abs(finiteOrNull(budget.preparation) || 0) / SQRT3,
    Math.abs(finiteOrNull(budget.homogeneity) || 0) / SQRT3,
    Math.abs(finiteOrNull(budget.stability) || 0) / SQRT3,
    Math.abs(finiteOrNull(budget.handling) || 0) / SQRT3,
    Math.abs(finiteOrNull(budget.other) || 0) / SQRT3,
  ]);
  const uc = rss([uStandard, uDrift, uResolution, uRepeatability, uTemp, uOther]);
  const k = 2;
  const uExpanded = k * uc;
  const toleranceValue = finiteOrNull(session.instrument_class);
  const tolerance = toleranceValue === null ? null : data.tolerance_mode === 'percent' ? Math.abs(patternMean) * toleranceValue / 100 : Math.abs(toleranceValue);
  const inTolerance = tolerance === null ? null : data.decision_rule === 'guard_band'
    ? Math.abs(errorAbs) + uExpanded <= tolerance : Math.abs(errorAbs) <= tolerance;
  return {
    pattern_mean: patternMean, instrument_mean: instrumentMean, error_abs: errorAbs, error_pct: errorPct,
    hysteresis: null, repeatability, u_standard: uStandard, u_drift: uDrift, u_resolution: uResolution,
    u_repeatability: uRepeatability, u_temp: uTemp, u_other: uOther, uc, k, u_expanded: uExpanded,
    u_reported: Math.max(uExpanded, Math.abs(Number(session.instrument_resolution) || 0)), in_tolerance: inTolerance, // piso por resolucion del instrumento (QA 2026-09-06)
    uncertainty_components: {
      reference_repeatability: referenceRepeatability,
      preparation: Math.abs(finiteOrNull(budget.preparation) || 0) / SQRT3,
      homogeneity: Math.abs(finiteOrNull(budget.homogeneity) || 0) / SQRT3,
      stability: Math.abs(finiteOrNull(budget.stability) || 0) / SQRT3,
      handling: Math.abs(finiteOrNull(budget.handling) || 0) / SQRT3,
      tolerance, decision_rule: data.decision_rule,
    },
  };
}

export function validateAnalyticalRowsForCalculation(rows = [], session = {}) {
  const issues = [];
  let expectedPointCount = 0;
  let completedPointCount = 0;
  rows.forEach((row, index) => {
    const pointNo = finiteOrNull(row?.point_no) ?? index + 1;
    const nominal = finiteOrNull(row?.setpoint);
    const rangeMin = finiteOrNull(session.instrument_range_min);
    const rangeMax = finiteOrNull(session.instrument_range_max);
    const inInstrumentRange = nominal !== null
      && (rangeMin === null || nominal >= rangeMin)
      && (rangeMax === null || nominal <= rangeMax);
    const covered = nominal !== null && evaluateAnalyticalReference(nominal, session).valid;
    if (covered && inInstrumentRange) expectedPointCount += 1;

    const metrics = computeAnalyticalPointMetrics(row, session);
    if (metrics?.traceability_issue) {
      issues.push(`Punto ${pointNo}: ${metrics.traceability_issue}`);
      return;
    }
    if (metrics) completedPointCount += 1;
    else if (covered && inInstrumentRange) issues.push(`Punto ${pointNo}: faltan las lecturas requeridas.`);
  });
  if (expectedPointCount === 0) issues.push('Ningún punto certificado compatible está dentro del alcance del instrumento.');
  if (completedPointCount === 0 && !issues.length) issues.push('Completá al menos un punto de calibración.');
  return {
    valid: issues.length === 0 && completedPointCount === expectedPointCount && expectedPointCount > 0,
    issues,
    expected_point_count: expectedPointCount,
    completed_point_count: completedPointCount,
  };
}
